<template>
  <div>
    <v-row dense>
      <v-col sm="2" xl="2" md="2" lg="2" class=" flex-justify-end flex-center">
        事件指派人：
      </v-col>
      <v-col sm="8" xl="8" md="8" lg="8">
        <form-item
          v-model="info.eventDispatchFlag"
          class=" flex-0 flex-shrink-0"
          :options="[{text:'显示',value:'1'},{text:'隐藏',value:'2'}]"
          style="width: 250px"
          dense
          type="radio"
          @input="$forceUpdate()"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col sm="2" xl="2" md="2" lg="2" class=" flex-justify-end flex-center">
        任务指派人：
      </v-col>
      <v-col sm="8" xl="8" md="8" lg="8">
        <form-item
          v-model="info.taskDispatchFlag"
          class=" flex-0 flex-shrink-0"
          :options="[{text:'显示',value:'1'},{text:'隐藏',value:'2'}]"
          style="width: 250px"
          dense
          type="radio"
          @input="$forceUpdate()"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="2" xl="2" md="2" lg="2" />
      <v-col sm="8" xl="8" md="8" lg="8">
        <v-btn small color="primary" depressed min-width="120" class="mr-2" height="30" style="padding:0 8px" @click="saveProgressLimit">保存</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      initInfo: {},
      info: {}
    }
  },
  mounted() {
    this.getDispatchLimit()
  },
  methods: {
    // 获取
    getDispatchLimit() {
      this.$http.get(this.$api.settingGetDispatchLimit, { data: {}, type: 'application/x-www-form-urlencoded' }).then(res => {
        this.initInfo = this.$deepClone(res.result || {})
        this.info = res.result || {}
      }).catch(() => {
        this.info = {}
      })
    },
    // 确认保存
    saveProgressLimit() {
      this.btnLoading = true
      this.$http.post(this.$api.settingSaveDispatchLimit, { data: { ...this.info }, type: 'application/x-www-form-urlencoded' }).then(res => {
        this.$message.success(res.result || res.message)
        this.btnLoading = false
      }).catch(() => {
        this.btnLoading = false
        this.info = this.$deepClone(this.initInfo)
      })
    }
  }
}
</script>

<style>

</style>
